var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.62,
    height: 29.62,
    viewBox: "0 0 30.62 29.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64768",
    "data-name": "Path 64768",
    d: "M16.568,19.81a2.383,2.383,0,1,1-2.382-2.3A2.329,2.329,0,0,1,16.568,19.81Zm3.742-2.3a2.305,2.305,0,1,0,2.382,2.3A2.329,2.329,0,0,0,20.31,17.506Zm6.124,0a2.305,2.305,0,1,0,2.382,2.3A2.329,2.329,0,0,0,26.434,17.506Zm9.186,2.3A15.089,15.089,0,0,1,20.31,34.62,15.089,15.089,0,0,1,5,19.81,15.089,15.089,0,0,1,20.31,5,15.089,15.089,0,0,1,35.62,19.81Zm-1.361,0A13.746,13.746,0,0,0,20.31,6.316,13.746,13.746,0,0,0,6.361,19.81,13.746,13.746,0,0,0,20.31,33.3,13.746,13.746,0,0,0,34.259,19.81Z",
    transform: "translate(-5 -5)",
    fill: "#515050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBtn);
export default __webpack_public_path__ + "static/media/actionBtn.2ecdd469a02419d15dd28341348ea3c6.svg";
export { ForwardRef as ReactComponent };